import React, { useEffect, useState } from "react";
import './CarouselVotosPartidos.css'
import CardPartido from "../Cards/CardPartido.js";
import ArrowModal from "../svg/ArrowModal";

/* Calcular la cantidad de cartas visibles según el tamaño de la pantalla*/
function calculateMatches() {
    return [
        { match: window.matchMedia("(min-width: 1920px)").matches, value: 5 },
        { match: window.matchMedia("(min-width: 1366px)").matches, value: 4 },
        { match: window.matchMedia("(min-width: 1200px)").matches, value: 3 },
        { match: window.matchMedia("(min-width: 1024px)").matches, value: 3 },
        { match: window.matchMedia("(min-width: 768px)").matches, value: 2 },
        { match: window.matchMedia("(min-width: 0px)").matches, value: 1 }
    ]
}


const CarouselVotosPartidos = ({ partidosData }) => {

    const [pagination, setPaginacion] = useState(0)
    const [paginationGroup, setPaginationGroup] = useState(1)
    const [matchesList, setMatches] = useState(calculateMatches())

    /* Refrescar media queries al cambiar el tamaño de pantalla*/
    useEffect(() => {
        window.addEventListener('resize', () => setMatches(calculateMatches()))
    }, []);

    /* Cambiar el tamaño de agrupación según la media query actual*/
    useEffect(() => {
        const found = matchesList.find(({ match }) => { return match === true; });
        setPaginationGroup(found.value)
    }, [matchesList]);

    /* Estar en la última página si se reducen la cantidad de páginas */
    useEffect(() => {
        const maxPaginación = Math.round(partidosData.length / paginationGroup) - 1
        if (pagination > maxPaginación) {
            setPaginacion(maxPaginación)
        }
    }, [pagination, paginationGroup, partidosData.length]);

    const showedData = partidosData.slice(paginationGroup * pagination, (pagination + 1) * paginationGroup);
    const maxPaginación = Math.round(partidosData.length / paginationGroup) - 1
    const lefArrowtDisabled = pagination === 0
    const rightArrowtDisabled = pagination === maxPaginación

    const radioButtons = []
    for (let i = 0; i < maxPaginación + 1; i++) {
        const activeClass = i === pagination ? 'active' : ''

        radioButtons.push(
            <div className={"carrousel__buttons__roundButton " + activeClass}
                key={'carrouselRadioButton' + i}
                onClick={() => { setPaginacion(i) }}
                onKeyDown={() => { setPaginacion(i) }}
                role="radio"
                aria-checked={i === pagination}
                tabIndex='0'
            />
        );
    }


    function previous() {
        if (!lefArrowtDisabled) {
            setPaginacion(pagination - 1)
        }
    }

    function next() {
        if (!rightArrowtDisabled) {
            setPaginacion(pagination + 1)
        }
    }

    function handleKeyDown(e) {
        switch (e.keyCode) {
            /** Flecha izquierda */
            case 37:
                previous();
                break;
            /** Flecha derecha */
            case 39:
                next();
                break;
            default: return false
        }
    }


    return (
        <>
            {
                showedData.length > 0 ?
                    (<div className="carrousel">
                        <div className="carrousel__inner">
                            <ArrowModal
                                direction='left'
                                disabled={lefArrowtDisabled}
                                onClick={previous}
                                onKeyDown={(e) => { handleKeyDown(e) }}
                                role="button"
                                tabIndex='0'
                            />
                            <div className="carrousel__inner__partidos">
                                {
                                    showedData.map((item, i) => <CardPartido key={item.codpar} {...item} />)
                                }
                            </div>
                            <ArrowModal
                                disabled={pagination === maxPaginación}
                                onClick={next}
                                onKeyDown={(e) => { handleKeyDown(e) }}
                                role="button"
                                tabIndex='0'
                            />

                        </div>
                        {
                            maxPaginación >= 0
                            && (
                                <div className="carrousel__buttons">
                                    {
                                        radioButtons
                                    }
                                </div>
                            )
                        }
                    </div>)
                    : (
                        <div>No hay datos de partidos</div>
                    )
            }

        </>
    )
}

export default CarouselVotosPartidos